import { render, staticRenderFns } from "./RoomStatusDetailChargeTab.vue?vue&type=template&id=0c502904"
import script from "./RoomStatusDetailChargeTab.vue?vue&type=script&lang=js"
export * from "./RoomStatusDetailChargeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports